export default __webpack_public_path__ + "static/media/ic_more.e0c53822.svg";